import React from 'react';
import Select from 'react-select';

export default function SelectDropdown({
    value,
    options,
    isMulti = false,
    onChange,
    isDisabled = false,
    placeholder = 'Search…',
    menuPortalTarget,
}) {
    const customStyles = {
        control: (provided) => ({
            ...provided,

            ':hover': {
                borderColor: '#8a49e2',
            },
            ':focus': {
                borderColor: '#8a49e2',
                boxShadow: '0 0 0 1px #2684FF',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#8a49e2' : state.isFocused ? '#e8def9' : 'white',
            color: state.isSelected ? 'white' : '#333',
        }),
    };

    let updatedOptions;
    if(!isMulti) {
        const basicOption = {
            value: '',
            label: 'Please Select Any Option'
        };
    
        if (!options || !Array.isArray(options)) {
            updatedOptions = [basicOption];
        } else {
            updatedOptions = [basicOption, ...options];
        }
    } else {
        updatedOptions = [...options];
    }
    
    const customFilterOption = (option, rawInput) => {
        if (!rawInput?.trim()) return true;
        const label = String(option.label || '').toLowerCase();
        const words = rawInput.toLowerCase().trim().split(/\s+/).filter(Boolean);
        return words.every((word) => label.includes(word));
    };

    return (
        <>
            <Select
                value={value}
                isMulti={isMulti}
                options={updatedOptions}
                onChange={(value) => onChange(value)}
                styles={customStyles}
                filterOption={customFilterOption}
                isDisabled={isDisabled}
                isSearchable
                placeholder={placeholder}
                menuPortalTarget={menuPortalTarget}
                menuPosition={menuPortalTarget ? 'fixed' : undefined}
            />
        </>
    );
}
